export default __webpack_public_path__ + "static/media/elec-2.ee501dba.png";